export default "dist/images/components-design-separator-control-slant-1.645f0b9.png";